import { yardManagementServiceStores } from "@intrasync/yard-management";
import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Service stores from `@intrasync/yard-management`.
 *
 * Replaces the hand-rolled `yard.stores.ts`, which registered the two services
 * behind the retired NTXYardMap screen (`yard-locations`, `yard-inventory-items`).
 * The module ships the full set — assets, asset types, zones, locations, tasks,
 * gate events, movements, grid layouts, layout blocks, placements, and the
 * `yards` root — under the same `yard-*` paths the API mounts at its default
 * namespace.
 *
 * Nothing is filtered here. ServiceStore registration is first-wins (see
 * StoreRegistry.registerServiceStore), so a name the host also registered would
 * shadow the module's — but the host no longer registers any `yard-*` service,
 * which is precisely what retiring the bespoke yard bought us. Re-check this if
 * a host-owned yard service is ever reintroduced.
 */
export const yardManagementStores =
  yardManagementServiceStores as unknown as ServiceStoreConfig[];
